import React, { useState } from "react";
import styled from "styled-components";
import {
    CognitoIdentityProviderClient,
    InitiateAuthCommand,
    RespondToAuthChallengeCommand,
} from "@aws-sdk/client-cognito-identity-provider";
import { CLIENT_ID, REGION } from "../aws/config";
import {useNavigate} from "react-router-dom";

const cognitoClient = new CognitoIdentityProviderClient({ region: REGION });

export default function Login() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();


    const storeTokens = (authResult) => {
        localStorage.setItem("accessToken", authResult.AccessToken);
        localStorage.setItem("idToken", authResult.IdToken);
        localStorage.setItem("refreshToken", authResult.RefreshToken);
        localStorage.setItem("username", username);
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setError("");

        const params = {
            AuthFlow: "USER_PASSWORD_AUTH",
            ClientId: CLIENT_ID,
            AuthParameters: {
                USERNAME: username,
                PASSWORD: password,
            },
        };

        try {
            const command = new InitiateAuthCommand(params);
            const response = await cognitoClient.send(command);

            if (response.ChallengeName === "NEW_PASSWORD_REQUIRED") {
                const newPassword = prompt("Your password needs to be reset. Please enter a new password:");

                if (!newPassword) {
                    setError("Password reset was canceled by the user.");
                    return;
                }

                const challengeResponse = new RespondToAuthChallengeCommand({
                    ClientId: CLIENT_ID,
                    ChallengeName: "NEW_PASSWORD_REQUIRED",
                    Session: response.Session,
                    ChallengeResponses: {
                        USERNAME: username,
                        NEW_PASSWORD: newPassword,
                    },
                });

                const finalResponse = await cognitoClient.send(challengeResponse);

                if (finalResponse.AuthenticationResult) {
                    storeTokens(finalResponse.AuthenticationResult);
                    navigate("/carpets");
                    console.log("Password updated and login successful", finalResponse);
                }
            } else if (response.AuthenticationResult) {
                storeTokens(response.AuthenticationResult);
                navigate("/carpets");
                console.log("Login successful", response);
            } else {
                setError("Unbekannter Fehler bei der Anmeldung.");
            }
        } catch (err) {
            console.error("Login error:", err);
            setError("Fehler bei der Anmeldung. Versuche es erneut.");
        }
    };

    return (
        <Wrapper>
            <FormWrapper>
                <h1>Anmeldung</h1>
                <Form onSubmit={handleLogin}>
                    <label>Benutzername:</label>
                    <Input
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                    <label>Passwort:</label>
                    <Input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    {error && <ErrorText>{error}</ErrorText>}
                    <SubmitWrapper>
                        <ButtonInput type="submit" value="Anmelden" />
                    </SubmitWrapper>
                </Form>
            </FormWrapper>
        </Wrapper>
    );
}

// Styled Components
const Wrapper = styled.section`
  padding-top: 105px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FormWrapper = styled.div`
  width: 100%;
  max-width: 400px;
  background-color: #f3f3f3;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const Input = styled.input`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 15px;
  &:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px #fff inset !important;
    -webkit-text-fill-color: #0B093B !important;
  }

  &:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px #fff inset !important;
    -webkit-text-fill-color: #0B093B !important;
  }

  &:-webkit-autofill:hover {
    -webkit-box-shadow: 0 0 0px 1000px #fff inset !important;
    -webkit-text-fill-color: #0B093B !important;
  }
`;

const ButtonInput = styled.input`
  padding: 12px;
  background-color: #7620ff;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    background-color: #5a0dcc;
  }
`;

const SubmitWrapper = styled.div`
  margin-top: 15px;
`;

const ErrorText = styled.p`
  color: red;
  font-size: 14px;
  text-align: center;
  margin-bottom: 10px;
`;